export const serializeMultiPromptFields = (fields) => {
  if (!fields) {
    return '';
  }
  return Object.values(fields)
    .map((field) => field.text)
    .join(' ')
    .trim();
};

export const serializeToolPrompts = (toolPrompts) => {
  if (!toolPrompts) {
    return '';
  }
  return Object.values(toolPrompts)
    .map((toolPrompt) => toolPrompt.prompt)
    .join(' ')
    .trim();
};
